/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteCatalogModelResponse = {
  id: string;
  deleted: boolean;
  deactivated: boolean;
};

/** @internal */
export const DeleteCatalogModelResponse$inboundSchema: z.ZodType<
  DeleteCatalogModelResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  deleted: z.boolean(),
  deactivated: z.boolean(),
});
/** @internal */
export type DeleteCatalogModelResponse$Outbound = {
  id: string;
  deleted: boolean;
  deactivated: boolean;
};

/** @internal */
export const DeleteCatalogModelResponse$outboundSchema: z.ZodType<
  DeleteCatalogModelResponse$Outbound,
  z.ZodTypeDef,
  DeleteCatalogModelResponse
> = z.object({
  id: z.string(),
  deleted: z.boolean(),
  deactivated: z.boolean(),
});

export function deleteCatalogModelResponseToJSON(
  deleteCatalogModelResponse: DeleteCatalogModelResponse,
): string {
  return JSON.stringify(
    DeleteCatalogModelResponse$outboundSchema.parse(deleteCatalogModelResponse),
  );
}
export function deleteCatalogModelResponseFromJSON(
  jsonString: string,
): SafeParseResult<DeleteCatalogModelResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteCatalogModelResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteCatalogModelResponse' from JSON`,
  );
}
